class ProductMetafieldPlans extends HTMLElement {
  constructor() {
    super();
    this.animations = [];
    this.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-floor-plan-trigger]');
      if (!trigger || !this.contains(trigger)) return;
      if (trigger.getAttribute('aria-pressed') === 'true') return;

      const selectedSlot = trigger.dataset.floorPlanTrigger;
      const outgoingTrigger = this.querySelector('[data-floor-plan-trigger][aria-pressed="true"]');
      const outgoingSlide = this.querySelector(`[data-floor-plan-slide="${outgoingTrigger?.dataset.floorPlanTrigger}"]`);
      const incomingSlide = this.querySelector(`[data-floor-plan-slide="${selectedSlot}"]`);
      const canAnimate = event.detail !== 0
        && typeof window.matchMedia === 'function'
        && typeof outgoingSlide?.animate === 'function'
        && typeof incomingSlide?.animate === 'function';

      this.querySelectorAll('[data-floor-plan-trigger]').forEach((button) => {
        button.setAttribute('aria-pressed', String(button === trigger));
      });

      this.cancelAnimations();

      if (!canAnimate) {
        this.showOnly(selectedSlot);
        return;
      }

      this.querySelectorAll('[data-floor-plan-slide]').forEach((slide) => {
        slide.toggleAttribute('hidden', slide !== outgoingSlide && slide !== incomingSlide);
      });

      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const easing = 'cubic-bezier(0.23, 1, 0.32, 1)';
      const animations = [
        outgoingSlide.animate([{ opacity: 1 }, { opacity: 0 }], { duration: 120, easing, fill: 'both' }),
        incomingSlide.animate(
          reducedMotion
            ? [{ opacity: 0 }, { opacity: 1 }]
            : [{ opacity: 0, transform: 'scale(.985)' }, { opacity: 1, transform: 'scale(1)' }],
          { duration: reducedMotion ? 120 : 180, easing, fill: 'both' },
        ),
      ];
      this.animations = animations;

      Promise.allSettled(animations.map((animation) => animation.finished)).then(() => {
        if (this.animations !== animations) return;
        this.showOnly(selectedSlot);
        this.cancelAnimations();
      });
    });
  }

  cancelAnimations() {
    this.animations.forEach((animation) => animation.cancel());
    this.animations = [];
  }

  showOnly(selectedSlot) {
    this.querySelectorAll('[data-floor-plan-slide]').forEach((slide) => {
      slide.toggleAttribute('hidden', slide.dataset.floorPlanSlide !== selectedSlot);
    });
  }
}

if (!customElements.get('product-metafield-plans')) {
  customElements.define('product-metafield-plans', ProductMetafieldPlans);
}
